<template>
  <Loading :loading="loading" :loading-text="''">
    <div class="practice-product-card archived-card">
      <!-- Image Area -->
      <div class="card-image-area">
        <div v-if="!imageSrc" class="placeholder-image archived-bg">
          <svg xmlns="http://www.w3.org/2000/svg" width="54" height="49" viewBox="0 0 54 49" fill="none">
            <path d="M39.3183 32.7161C42.398 32.7161 44.8945 30.252 44.8945 27.2125C44.8945 24.173 42.398 21.709 39.3183 21.709C36.2387 21.709 33.7422 24.173 33.7422 27.2125C33.7422 30.252 36.2387 32.7161 39.3183 32.7161Z" fill="#C4C4C4"/>
            <path d="M8.13304 17.8511C12.6248 17.8511 16.2661 14.2573 16.2661 9.824C16.2661 5.39074 12.6248 1.79688 8.13304 1.79688C3.64128 1.79688 0 5.39074 0 9.824C0 14.2573 3.64128 17.8511 8.13304 17.8511Z" fill="#9A9A9A"/>
            <path d="M45.1018 17.8511C49.5935 17.8511 53.2348 14.2573 53.2348 9.824C53.2348 5.39074 49.5935 1.79688 45.1018 1.79688C40.61 1.79688 36.9688 5.39074 36.9688 9.824C36.9688 14.2573 40.61 17.8511 45.1018 17.8511Z" fill="#9A9A9A"/>
            <path d="M26.4885 48.5035C30.9803 48.5035 34.6215 44.9096 34.6215 40.4763C34.6215 36.0431 30.9803 32.4492 26.4885 32.4492C21.9968 32.4492 18.3555 36.0431 18.3555 40.4763C18.3555 44.9096 21.9968 48.5035 26.4885 48.5035Z" fill="#9A9A9A"/>
            <path d="M15.9293 7.53084C15.9293 7.53084 18.5112 16.0341 26.4968 16.0341C34.9947 16.0341 37.3192 7.52344 37.3192 7.52344L43.3177 17.6572C43.3177 17.6572 34.03 15.3828 30.0134 22.2777C25.9969 29.1725 31.718 34.3282 31.718 34.3282H21.2631C21.2631 34.3282 26.5118 28.6545 22.9826 22.2777C19.0361 15.1707 10.6406 17.4722 10.6406 17.4722L15.9293 7.53084Z" fill="#9A9A9A"/>
            <path d="M26.6191 11.0071C29.6987 11.0071 32.1953 8.54306 32.1953 5.50354C32.1953 2.46402 29.6987 0 26.6191 0C23.5395 0 21.043 2.46402 21.043 5.50354C21.043 8.54306 23.5395 11.0071 26.6191 11.0071Z" fill="#C4C4C4"/>
            <path d="M13.709 32.7161C16.7886 32.7161 19.2851 30.252 19.2851 27.2125C19.2851 24.173 16.7886 21.709 13.709 21.709C10.6293 21.709 8.13281 24.173 8.13281 27.2125C8.13281 30.252 10.6293 32.7161 13.709 32.7161Z" fill="#C4C4C4"/>
          </svg>
        </div>
        <div v-else class="product-image">
          <img :src="imageSrc" :alt="product.name" />
          <div class="image-overlay"></div>
        </div>

        <!-- Status Badge -->
        <div class="status-badge archived">Archived</div>
      </div>

      <!-- Card Content -->
      <div class="card-content">
        <!-- Title Row with Actions -->
        <div class="card-title-row">
          <h3 class="card-title">{{ product.name }}</h3>
          <div v-if="!loading" class="card-actions">
            <button class="action-btn restore-btn" @click="$emit('restore-product', product)" title="Restore">
              <img src="@/assets/MyWorkBench/archive/restore.svg" alt="Restore" class="action-icon" />
              <span class="action-text">Restore</span>
            </button>
            <button class="action-btn delete-btn" @click="$emit('delete-product', product)" title="Delete Permanently">
              <img src="@/assets/MyWorkBench/archive/delete.svg" alt="Delete" class="action-icon" />
              <span class="action-text">Permanently Delete</span>
            </button>
          </div>
        </div>

        <!-- Description -->
        <p class="card-description">{{ product.description || "Currently we don't have product description..." }}</p>

        <!-- Details Rows -->
        <div class="card-details">
          <div class="detail-row">
            <span class="detail-key">Price</span>
            <span class="detail-value">{{ product.price }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-key">Type</span>
            <span class="detail-value">{{ capitalizeFirst(product.type) }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-key">Refund Days</span>
            <span class="detail-value">{{ product.returnDays }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-key">Refund Policy</span>
            <span class="detail-value">{{ product.refundPolicy }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-key">Revenue YTD</span>
            <span class="detail-value">{{ revenueYtd }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-key">Sold YTD</span>
            <span class="detail-value">{{ soldYtdDisplay }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-key">Assignees</span>
            <span class="detail-value assignees-value">
              {{ assigneesCount }}
              <img src="@/assets/MyWorkBench/archive/assignee.svg" alt="Assignees" class="assignees-icon" />
            </span>
          </div>
        </div>
      </div>
    </div>
  </Loading>
</template>

<script>
import { downloadFile } from '@/api/markup';
import Loading from '@/NewLibrary/Loading/Loading.vue';

export default {
  name: 'PracticeProductCard',
  components: {
    Loading,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    currencySymbol: {
      type: String,
      default: '$',
    },
    soldInfo: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['restore-product', 'delete-product'],
  data() {
    return {
      imageSrc: null,
    };
  },
  computed: {
    revenueYtd() {
      if (this.soldInfo && this.soldInfo.revenueYtd != null) {
        return `${this.currencySymbol}${this.soldInfo.revenueYtd.toFixed(2)}`;
      }
      return `${this.currencySymbol}0.00`;
    },
    soldYtdDisplay() {
      if (this.soldInfo && this.soldInfo.soldAmountYtd != null) {
        return this.soldInfo.soldAmountYtd;
      }
      return 0;
    },
    assigneesCount() {
      // Note: API returns apply_to_all_providers, not isAll
      // isAll = apply_to_all_providers (per VA Portal dataFomatter)
      if (!this.product.providerList) return 0;
      if (this.product.apply_to_all_providers) return 'All';
      if (this.product.apply_to_self) return 'Only me';
      return this.product.providerList.length;
    },
  },
  watch: {
    'product.image': {
      async handler(newVal) {
        if (!newVal) {
          this.imageSrc = null;
          return;
        }
        await this.getImageSrc();
      },
    },
  },
  async mounted() {
    if (this.product && this.product.image) {
      await this.getImageSrc();
    }
  },
  methods: {
    capitalizeFirst(str) {
      if (!str) return '';
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    async getImageSrc() {
      if (!this.product.image) return;
      try {
        const parts = this.product.image.split('/');
        const folderName = parts[0];
        const fileName = parts[parts.length - 1];
        const { data } = await downloadFile(folderName, fileName);
        this.imageSrc = URL.createObjectURL(data);
      } catch (error) {
        this.imageSrc = null;
      }
    },
  },
};
</script>

<style scoped>
.practice-product-card {
  border-radius: 8px;
  border: 1px solid var(--color-Grey-Grey-E8, #E0E0E0);
  background: var(--color-White-000, #FFF);
  box-shadow: 0 1px 15px 0 rgba(164, 164, 164, 0.25);
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-height: 404px;
  height: fit-content;
  align-self: start;
  overflow: hidden;
}

.archived-card {
  border: 1px solid transparent;
  background: var(--Cool-White, #F9FBFD);
  opacity: 0.8;
}

/* Image Area */
.card-image-area {
  position: relative;
  height: 134px;
  width: 100%;
  border-radius: 5px;
  overflow: hidden;
}

.placeholder-image {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
}

.placeholder-image.archived-bg {
  background: var(--Grey-White, #F2F2F2);
}

.product-image {
  width: 100%;
  height: 100%;
  position: relative;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}

.image-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 5px;
  pointer-events: none;
}

/* Status Badge */
.status-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  display: inline-block;
  padding: 4px 8px;
  border-radius: 8px;
  background: rgba(249, 251, 253, 0.90);
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.4px;
}

.status-badge.archived {
  color: var(--TrueBlack, #333);
  border: 1px solid #E6E6E6;
}

/* Card Content */
.card-content {
  padding: 4px 8px 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  align-self: stretch;
}

.card-title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
  gap: 4px;
  align-self: stretch;
}

.card-title {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: var(--TrueBlack, #333);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  flex: 1 0 0;
  margin: 0;
}

.card-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0px;
  flex-shrink: 0;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 4px 6px;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 4px;
  white-space: nowrap;
  min-width: 24px;
  height: 32px;
}

.action-icon {
  flex-shrink: 0;
  display: block;
}

.action-text {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  max-width: 0;
  overflow: hidden;
  opacity: 0;
  transition: all 0.2s ease;
}

.restore-btn:hover {
  background: rgba(0, 72, 121, 0.08);
}

.restore-btn:hover .action-icon {
  filter: grayscale(1) brightness(0.5);
}

.restore-btn:hover .action-text {
  max-width: 180px;
  overflow: visible;
  opacity: 1;
  color: #1E4670;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  transition: all 0.8s ease;
}

.delete-btn:hover {
  background: #FFEBEE;
  color: #D10000;
}

.delete-btn:hover .action-icon {
  filter: brightness(1.1);
}

.delete-btn:hover .action-text {
  max-width: 180px;
  overflow: visible;
  opacity: 1;
  color: #D10000;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  transition: all 0.8s ease;
}

/* Description */
.card-description {
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: var(--color-Grey-Grey-97, #979797);
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  align-self: stretch;
}

/* Detail Rows */
.card-details {
  display: flex;
  padding-top: 8px;
  margin-top: 4px;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  align-self: stretch;
  border-top: 1px solid var(--color-Grey-Grey-E8, #E0E0E0);
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 24px;
  align-self: stretch;
}

.detail-key {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: var(--SecondaryBlack, #666);
}

.detail-value {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: var(--SecondaryBlack, #666);
}

.status-text {
  color: #856404;
  font-weight: 500;
}

.assignees-value {
  display: flex;
  align-items: center;
  gap: 4px;
}

.assignees-value svg {
  width: 16px;
  height: 12px;
}
</style>
